var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.512464 0.563229C0.532118 0.524443 0.571907 0.5 0.615388 0.5H4.55416C4.59091 0.5 4.62547 0.517512 4.6472 0.547151L5.05041 0.251476L4.6472 0.547152L8.80506 6.21712L9.14971 6.68711L9.56182 6.275L15.303 0.533795C15.3481 0.488734 15.4211 0.488735 15.4662 0.533796C15.5113 0.578855 15.5113 0.651915 15.4662 0.696975L9.5911 6.57208L9.28778 6.87539L9.54145 7.22131L15.4777 15.3164C15.5034 15.3514 15.5072 15.398 15.4875 15.4368C15.4679 15.4756 15.4281 15.5 15.3846 15.5H11.4458C11.4091 15.5 11.3745 15.4825 11.3528 15.4529L7.19494 9.78288L6.85029 9.31289L6.43818 9.725L0.696974 15.4662C0.651915 15.5113 0.578855 15.5113 0.533794 15.4662C0.488734 15.4211 0.488736 15.3481 0.533794 15.303L6.4089 9.42792L6.71222 9.1246L6.45856 8.77869L0.52234 0.683617C0.496628 0.648554 0.492809 0.602014 0.512464 0.563229ZM0.512464 0.563229L0.073595 0.340833L0.512464 0.563229ZM9.0835 6.98705L9.06709 6.96467L9.0483 6.94425C9.04213 6.93754 9.03716 6.93064 9.03315 6.92365L9.01924 6.89943L9.00272 6.8769L4.64552 0.935093L4.49569 0.73077H4.24231H1.82977H0.843085L1.42656 1.52645L11.3545 15.0649L11.5043 15.2692H11.7577H14.1702H15.1569L14.5734 14.4736L9.0835 6.98705Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXOutline);
export default __webpack_public_path__ + "static/media/X-outline.d297f736a63369e375095c8b1cdef094.svg";
export { ForwardRef as ReactComponent };